<template>
  <div>
    <p class="cm-mg-p-wzd">
      2.1 {{ $t('common_words.calendar_detailed_info') }}
    </p>
    <hr />
    <el-container style="border: 1px solid #eee">
      <el-aside width="20%" style="overflow-x: hidden">
        <div
          class="row"
          style="
            margin: 10px auto;
            width: 30%;
            font-size: 25px;
            cursor: pointer;
          "
        >
          <div class="col-4">
            <em
              v-tooltip.top-center="$t('common_words.year_add')"
              class="el-icon-circle-plus"
              @click="addYear"
            ></em>
          </div>
          <div class="col-4">
            <em
              v-tooltip.top-center="$t('common_words.year_delete')"
              class="el-icon-remove"
              @click="removeYear"
            ></em>
          </div>
        </div>
        <el-menu :default-openeds="['1']">
          <el-submenu index="1">
            <template slot="title"
              ><em class="el-icon-date"></em
              >{{ $t('common_words.years') }}</template
            >
            <el-menu-item-group class="custom-el-menu-item-group-cal">
              <el-menu-item
                @click="changeOptionYear(y)"
                v-for="(y, i) in model.years"
                :key="y"
                v-bind:class="i == 0 ? 'is-active' : ''"
                v-bind:index="y + '-' + y"
                style="min-width: 140px"
                class="custom-el-menu-item-cal"
              >
                {{ y }}
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-container v-if="renderComponent">
        <el-main>
          <div class="row">
            <div class="col-2 text-center custom-head-dark">
              {{ $t('common_words.week') }}
            </div>
            <div class="col-3 text-center custom-head-dark">
              {{ $t('common_words.starting_week') }}
            </div>
            <div class="col-3 text-center custom-head-dark">
              {{ $t('common_words.end_week') }}
            </div>
            <div class="col-3 text-center custom-head-dark">
              {{ $t('production.ribbon') }}
            </div>
          </div>
          <div
            class="row"
            v-for="(w, j) in model.weeks[model.yearSel]"
            :key="j"
          >
            <div class="col-2 text-center">
              <p class="m-2" style="padding: 10px">{{ w }}</p>
            </div>
            <div class="col-3 text-center">
              <el-date-picker
                v-if="renderComponent"
                v-on:input="setEndDateWeek(w - 1)"
                v-model="model.init_dates_week[model.yearSel][w - 1]"
                type="date"
                v-bind:class="
                  w < 53
                    ? 'shadow-sm required text-center m-2'
                    : 'shadow-sm text-center m-2'
                "
                :placeholder="`${$t('common_words.select2')}...`"
              >
              </el-date-picker>
            </div>
            <div class="col-3 text-center">
              <el-date-picker
                v-if="renderComponent"
                v-on:input="setInitDateWeek(w - 1)"
                v-model="model.end_dates_week[model.yearSel][w - 1]"
                type="date"
                v-bind:class="
                  w < 53
                    ? 'shadow-sm required text-center m-2'
                    : 'shadow-sm text-center m-2'
                "
                :placeholder="`${$t('common_words.select2')}...`"
              >
              </el-date-picker>
            </div>
            <div class="col-3 text-center">
              <el-select
                clearable
                v-on:input="forceRenderer(false, w)"
                style="width: 100%"
                v-bind:class="
                  w < 53
                    ? 'select-default shadow-sm required-second-step text-center m-2'
                    : 'select-default shadow-sm text-center m-2'
                "
                v-model="model.ribbons[model.yearSel][w - 1]"
                :placeholder="`${$t('common_words.select2')}...`"
              >
                <el-option
                  v-for="(r, k) in ribbons"
                  :key="k"
                  class="select-default text-center"
                  :label="r.color_name"
                  :value="r.id"
                ></el-option>
              </el-select>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import i18n from 'src/i18n';
import MixinForm from 'src/mixins/forms/mixin-form';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import store from '@/store';
import SweetAlert from 'src/class/Alerts';

export default {
  data() {
    return {
      model: {
        weeks: { [moment().format('Y')]: [] },
        init_dates_week: { [moment().format('Y')]: [] },
        end_dates_week: { [moment().format('Y')]: [] },
        ribbons: { [moment().format('Y')]: [] },
        years: [moment().format('Y')],
        yearSel: null,
        details_id: {},
      },
      modelValidations: {
        week: { required: true },
      },
      ribbons: [],
      renderComponent: true,
    };
  },
  mixins: [MixinPermissions, MixinForm, mixinMasters],
  watch: {
    '$i18n.locale': 'forceRerender',
  },
  methods: {
    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', res, this.model);
          let others = {};
          this.model.years.forEach((y) => {
            others[y] = [];
            this.ribbons.forEach((item) => {
              if (this.model.ribbons[y]) {
                this.model.ribbons[y].forEach((element, index) => {
                  if (element == item.id) {
                    let rb = {};
                    rb.color_name = item.color_name;
                    rb.color_code = item.color_code;
                    rb.color_text = item.color_text;
                    this.$set(others[y], index, rb);
                  }
                });
              }
            });
          });

          this.$emit('fillCalendarForm', 'secondStep', {
            names_ribbons: others,
          });
          return res;
        })
        .then((resp) => {
          if (!resp) return resp;

          return store.dispatch('utils/validationInputsRequired', '');
        })
        .then((resp) => {
          if (!resp) return resp;

          return store.dispatch(
            'utils/validationInputsRequired',
            '-second-step'
          );
        })
        .then((resp) => {
          if (!resp) return resp;
          let r = true;
          this.model.years.forEach((element) => {
            if (
              (this.model.init_dates_week[element] &&
                this.model.init_dates_week[element].length < 52) ||
              (this.model.end_dates_week[element] &&
                this.model.end_dates_week[element].length < 52) ||
              (this.model.ribbons[element] &&
                this.model.ribbons[element].length < 52)
            ) {
              r = false;
              this.forceRenderer();
              this.model.yearSel =
                this.model.years[this.model.years.length - 1];
              this.activeItemYear();
              setTimeout(() => {
                return store.dispatch('utils/validationInputsRequired', '');
              }, 20);
            }
          });

          return r;
        });
    },

    setEndDateWeek(indexDate) {
      this.showHideLoading(true);
      this.forceRenderer();

      let init = this.model.init_dates_week[this.model.yearSel][indexDate];
      let end;
      if (init) {
        end = new Date(init.setDate(init.getDate() + 6));
        this.$set(
          this.model.init_dates_week[this.model.yearSel],
          indexDate,
          new Date(init.setDate(init.getDate() - 6))
        );

        for (let index = indexDate + 1; index < 52; index++) {
          this.$set(
            this.model.init_dates_week[this.model.yearSel],
            index,
            new Date(init.setDate(init.getDate() + 7))
          );
          this.$set(
            this.model.end_dates_week[this.model.yearSel],
            index,
            new Date(end.setDate(end.getDate() + 7))
          );
        }

        end = this.model.init_dates_week[this.model.yearSel][indexDate];
        this.$set(
          this.model.end_dates_week[this.model.yearSel],
          indexDate,
          new Date(end.setDate(end.getDate() + 6))
        );
        this.$set(
          this.model.init_dates_week[this.model.yearSel],
          indexDate,
          new Date(end.setDate(end.getDate() - 6))
        );
      }
    },

    setInitDateWeek(indexDate) {
      this.showHideLoading(true);
      this.forceRenderer();

      let init = this.model.init_dates_week[this.model.yearSel][indexDate];
      let end = this.model.end_dates_week[this.model.yearSel][indexDate];
      if (end) {
        init = new Date(end.setDate(end.getDate() - 6));
        new Date(end.setDate(end.getDate() + 6));
        this.$set(
          this.model.init_dates_week[this.model.yearSel],
          indexDate,
          init
        );
      }
    },

    loadWeeks(year_sel = null) {
      let index = 0;
      for (index; index < 53; index++) {
        this.$set(
          this.model.weeks[year_sel ? year_sel : this.model.yearSel],
          index,
          index + 1
        );
      }
    },

    /** Método que abre un modal para ingresar el año en especifico
     * validando que este año no esté presente antes de añadirlo
     */
    addYear() {
      SweetAlert.input(
        i18n.t('production.enter_year'),
        null,
        i18n.t('common_words.accept'),
        {
          type: 'number',
          placeholder: '',
        }
      )
        .then((result) => {
          if (!result.dismiss) {
            const year = result.value;
            if (year && !isNaN(year) && year > 1999 && year < 2101) {
              if (!this.model.years.includes(year)) {
                let newYear = Number.parseInt(year);
                this.model.years.unshift(newYear.toString());
                this.activeItemYear();

                this.model.yearSel = this.model.years[0];
                this.model.weeks[this.model.yearSel] = [];
                this.model.init_dates_week[this.model.yearSel] = [];
                this.model.end_dates_week[this.model.yearSel] = [];
                this.model.ribbons[this.model.yearSel] = [];
                this.model.details_id[this.model.yearSel] = [];

                setTimeout(() => {
                  this.forceRenderer(true);
                }, 100);
              } else {
                SweetAlert.warning(i18n.t('production.year_already_exists'));
              }
            } else {
              SweetAlert.warning(
                i18n.t('common_words.must_enter_valid_number')
              );
            }
          }
        })
        .catch((error) => {
          console.error('Error con el modal:', error);
        });
    },

    removeYear() {
      if (this.model.years.length > 1) {
        this.showHideLoading(true);

        let id = this.model.years.shift();
        delete this.model.weeks[id];
        delete this.model.init_dates_week[id];
        delete this.model.end_dates_week[id];
        delete this.model.ribbons[id];
        delete this.model.details_id[id];

        this.forceRenderer();
        this.model.yearSel = this.model.years[this.model.years.length - 1];
        this.activeItemYear();
      }
    },

    activeItemYear() {
      Object.values(
        document.getElementsByClassName('custom-el-menu-item-cal')
      ).forEach((element) => {
        element.classList.remove('is-active');
      });

      setTimeout(() => {
        Object.values(
          document.getElementsByClassName('custom-el-menu-item-cal')
        )[0].classList.add('is-active');
      }, 20);
    },

    changeOptionYear(yearSel, $event) {
      this.showHideLoading(true);
      this.model.yearSel = yearSel;
      try {
        let obj = event.target;
        setTimeout(() => {
          Object.values(
            document.getElementsByClassName('custom-el-menu-item-cal')
          ).forEach((element) => {
            if (obj != element) {
              element.classList.remove('is-active');
            }
          });
          this.showHideLoading();
        }, 20);
      } catch (error) {
        console.log(error);
        this.showHideLoading();
      }
    },

    forceRenderer(loadWeeks = false, indexRibbon = 0) {
      this.renderComponent = false;
      this.renderComponent = true;

      if (loadWeeks) {
        this.loadWeeks();
      }

      if (indexRibbon == 8) {
        let r = 0;
        for (let index = 9; index < 53; index++) {
          this.model.ribbons[this.model.yearSel][index - 1] =
            this.model.ribbons[this.model.yearSel][r];
          r = r == indexRibbon - 1 ? 0 : r + 1;
        }
      }

      this.showHideLoading();
    },
  },

  created() {
    if (this.isCreate() || this.isUpdate()) {
      let editForm = {};
      this.showHideLoading(true);

      if (this.isUpdate() && sessionStorage.getItem('editForm')) {
        editForm = JSON.parse(sessionStorage.getItem('editForm'));
        if (isset(editForm.years)) {
          this.model.years = editForm.years
            .sort((a, b) => b.year - a.year)
            .map((y) => y.year);

          this.model.weeks = {};
          this.model.init_dates_week = {};
          this.model.end_dates_week = {};
          this.model.ribbons = {};
          this.model.details_id = {};

          this.model.years.forEach((element) => {
            this.model.weeks[element] = [];
            this.model.init_dates_week[element] = [];
            this.model.end_dates_week[element] = [];
            this.model.ribbons[element] = [];
            this.model.details_id[element] = [];
            this.loadWeeks(element);
          });

          if (this.model.years[0]) {
            this.model.yearSel = this.model.years[0];
            this.forceRenderer();
          }

          for (let i = this.model.years.length - 1; i >= 0; i--) {
            const cdOrdered = editForm.calendar_details.sort((a, b) => {
              let keyA = Object.keys(a)[0];
              let keyB = Object.keys(b)[0];

              return keyB - keyA;
            });

            const position = this.model.years.length - 1 - i;
            const calendarDetail = cdOrdered[position];
            const yearSel = this.model.years[position];
            if (
              calendarDetail[yearSel] &&
              calendarDetail[yearSel].calendar_details
            ) {
              Object.values(calendarDetail[yearSel].calendar_details).forEach(
                (data) => {
                  this.model.init_dates_week[yearSel].push(
                    moment(data.init_date_week).format('Y-M-D')
                  );
                  this.model.end_dates_week[yearSel].push(
                    moment(data.end_date_week).format('Y-M-D')
                  );
                  this.model.ribbons[yearSel].push(data.ribbon.id);
                  this.model.details_id[yearSel].push(
                    data.week + '-' + data.id
                  );
                }
              );
            }
          }
        }

        this.showHideLoading();
      }

      if (this.model.years[0]) {
        this.model.yearSel = this.model.years[0];
        this.loadWeeks();
      }

      Axios.getMasters('ribbons').then((response) => {
        this.ribbons = response.data.data;
      });
    }
  },

  mounted() {},
};
</script>
<style></style>
